<!-- ADD/EDIT NOTA DE VENTA -->
<div [hidden]="!mostrar">
  <app-cabecera-nota-venta (onHeaderDataChange)="handleHeaderDataChange($event)"
    [permiteUnidadNegocio]="permiteUnidadNegocio" [optionsUnidadesDeNegocio]="optionsUnidadesDeNegocio">
  </app-cabecera-nota-venta>

  <app-detalle-nota-venta (onAddProductoRequest)="onAddProductoRequest($event)"
    (onDeleteProductoRequest)="onDeleteProductoRequest($event)" [permiteUnidadNegocio]="permiteUnidadNegocio"
    [cabeceraComponent]="cabeceraComponent"></app-detalle-nota-venta>

  <div class="card mb-2 wow">
    <div class="card-body d-sm-flex p-1 ">

      <div>
        <button size="sm" class="btn btn-sm ColorBtnClose" mdbBtn type="button" color="info" mdbWavesEffect
          (click)="CloseNotaVenta()">
          Cerrar
        </button>
      </div>
      <div class="card-body d-sm-flex p-1  justify-content-end">
        <!-- <button size="sm" class="btn btn-sm" mdbBtn type="button" color="info" mdbWavesEffect (click)="clearFromButton()">
        Limpiar
      </button> -->

        <app-api-button (click2)="guardarNotaVenta()" [processing]="processing">
          Guardar
        </app-api-button>
      </div>



    </div>
  </div>



  <app-modal-confirm title="Limpiar datos" contentText="¿Desea limpiar los datos ingresados?">
  </app-modal-confirm>

</div>